import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

type Translations = Record<string, any>;

@Injectable({ providedIn: 'root' })
export class I18nService {
  private translations = signal<Translations>({});

  constructor(private http: HttpClient) {}

  load(language: string): Promise<void> {
    return new Promise((resolve) => {
      this.http
        .get<Translations>(`assets/i18n/${language}.json`)
        .subscribe((data) => {
          this.translations.set(data);
          resolve();
        });
    });
  }

  t(path: string, params?: Record<string, any>): string {
    const value = path
      .split('.')
      .reduce((obj, key) => obj?.[key], this.translations());
    if (typeof value === 'string') {
      if (params) {
        return Object.keys(params).reduce((result, key) => {
          return result.replace(
            new RegExp(`{{\\s*${key}\\s*}}`, 'g'),
            String(params[key])
          );
        }, value);
      }
      return value;
    }
    return path;
  }
}
